export const MAP_COMPONENT_SET_CENTER = 'MAP_COMPONENT/SET_CENTER';
export const MAP_COMPONENT_SET_ZOOM = 'MAP_COMPONENT/SET_ZOOM';
export const MAP_COMPONENT_SET_CENTER_AND_ZOOM = 'MAP_COMPONENT/SET_CENTER_AND_ZOOM';
export const MAP_COMPONENT_SET_ZOOM_TO_BOUNDS = 'MAP_COMPONENT/SET_ZOOM_TO_BOUNDS';
export const MAP_COMPONENT_SET_LAST_BOUNDS = 'MAP_COMPONENT/SET_LAST_BOUNDS';
export const MAP_COMPONENT_SET_AFTER_MARKERS_LOADED_BOUNDS = 'MAP_COMPONENT/SET_AFTER_MARKERS_LOADED_BOUNDS';
export const DISALLOW_STREET_VIEW = 'MAP_COMPONENT/DISALLOW_STREET_VIEW';
export const ALLOW_STREET_VIEW = 'MAP_COMPONENT/ALLOW_STREET_VIEW';
